"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _style = _interopRequireDefault(require("./style.css"));
var _util = require("./util.js");
var _get2 = _interopRequireDefault(require("lodash/get"));
var _find2 = _interopRequireDefault(require("lodash/find"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var FrequencyTable = function FrequencyTable(props) {
  var renderFrequencyTable = function renderFrequencyTable(chart) {
    var valueHeader = props.valueHeader,
      mapHeader = props.mapHeader,
      labels = props.labels,
      map = props.map,
      showPercentage = props.showPercentage;
    var uniqueLabels = _toConsumableArray(new Set(labels));
    var usesMap = labels.length === uniqueLabels.length && map.length > 0;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].freqTableWrap
    }, /*#__PURE__*/_react["default"].createElement("table", {
      className: _style["default"].freqTable
    }, /*#__PURE__*/_react["default"].createElement("thead", null, /*#__PURE__*/_react["default"].createElement("tr", {
      className: _style["default"].barBelow
    }, /*#__PURE__*/_react["default"].createElement("th", {
      className: _style["default"].tableLabel
    }, valueHeader), usesMap && /*#__PURE__*/_react["default"].createElement("th", {
      className: _style["default"].tableLabel
    }, mapHeader), /*#__PURE__*/_react["default"].createElement("th", null, "Frequency"), showPercentage && /*#__PURE__*/_react["default"].createElement("th", null, "Percentage"))), /*#__PURE__*/_react["default"].createElement("tbody", null, renderFrequencyTableRows(chart))));
  };
  var getFrequencyTableData = function getFrequencyTableData() {
    var data = props.data,
      labelPath = props.labelPath,
      valuePath = props.valuePath,
      ignoreLabels = props.ignoreLabels,
      ignoreValues = props.ignoreValues,
      labels = props.labels;
    var uniqueLabels = _toConsumableArray(new Set(labels));
    var populated = uniqueLabels.map(function (item) {
      var row = [];
      row.parentLink = 1;
      row[labelPath] = item;
      row[valuePath] = (0, _get2["default"])((0, _find2["default"])(data, [labelPath, item]), valuePath, 0);
      return row;
    });
    var filtered = populated.filter(function (row) {
      return !ignoreLabels.includes(row[labelPath]) && !ignoreValues.includes(row[valuePath]);
    });
    var total = filtered.reduce(function (cume, row) {
      return cume + row[valuePath];
    }, 0);
    var sorted = sortRows(filtered);
    return sorted.map(function (row) {
      return {
        label: row[labelPath],
        value: row[valuePath],
        percentage: total === 0 ? 0 : parseFloat(row[valuePath]) * 100.0 / parseFloat(total)
      };
    }).concat([{
      label: 'TOTAL ',
      value: total,
      percentage: total === 0 ? 'NA' : 100.0
    }]);
  };
  var sortRows = function sortRows(data) {
    var newData = data;
    var labels = props.labels;
    var order = {};
    var index = 1;
    var _iterator = _createForOfIteratorHelper(labels),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var label = _step.value;
        order[label] = index;
        index++;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    if (props.orderByLabel) {
      if (props.orderByNumeric) {
        newData.sort((0, _util.sortByValueNumeric)(props.labelPath));
      } else {
        newData.sort((0, _util.sortByValue)(props.labelPath));
      }
    } else if (props.orderByValue) {
      if (props.orderByNumeric) {
        newData.sort((0, _util.sortByValueNumeric)(props.valuePath));
      } else {
        newData.sort((0, _util.sortByValue)(props.valuePath));
      }
    } else {
      // preserve order of labels
      newData.sort(function (a, b) {
        return order[a[props.labelPath]] - order[b[props.labelPath]];
      });
    }
    if (props.reverseData) {
      newData.reverse();
    }
    return newData;
  };
  var renderFrequencyTableRows = function renderFrequencyTableRows() {
    var data = getFrequencyTableData();
    var map = props.map,
      showPercentage = props.showPercentage,
      labels = props.labels;
    var uniqueLabels = _toConsumableArray(new Set(labels));
    var usesMap = labels.length === uniqueLabels.length && map.length > 0;
    return data.map(function (row, index) {
      var mapped = null;
      if (usesMap) {
        if (row.label in map) {
          mapped = /*#__PURE__*/_react["default"].createElement("td", {
            className: _style["default"].tableLabel
          }, map[row.label]);
        } else {
          mapped = /*#__PURE__*/_react["default"].createElement("td", {
            className: _style["default"].tableLabel
          }, "\xA0");
        }
      }
      return /*#__PURE__*/_react["default"].createElement("tr", {
        key: index,
        className: row.label === 'TOTAL ' ? _style["default"].barAbove : ''
      }, /*#__PURE__*/_react["default"].createElement("td", {
        className: _style["default"].tableLabel
      }, row.label), usesMap && mapped, /*#__PURE__*/_react["default"].createElement("td", null, row.value), showPercentage && /*#__PURE__*/_react["default"].createElement("td", {
        className: _style["default"].tableValue
      }, row.percentage === 'NA' ? 'NA' : row.percentage.toFixed(1) + '%'));
    });
  };
  return renderFrequencyTable();
};
FrequencyTable.propTypes = {
  data: _propTypes["default"].array.isRequired,
  map: _propTypes["default"].array,
  labels: _propTypes["default"].array,
  labelPath: _propTypes["default"].string,
  valuePath: _propTypes["default"].string,
  ignoreLabels: _propTypes["default"].array,
  ignoreValues: _propTypes["default"].array,
  valueHeader: _propTypes["default"].string,
  mapHeader: _propTypes["default"].string,
  showPercentage: _propTypes["default"].bool
};
FrequencyTable.defaultProps = {
  map: [],
  labels: [],
  showPercentage: true,
  labelPath: 'value',
  valuePath: 'valueCount',
  ignoreLabels: [],
  ignoreValues: [],
  valueHeader: 'Value',
  mapHeader: 'Coding'
};
var _default = exports["default"] = FrequencyTable;